import { PLATFORM } from '../config.js'
import { SETTINGS } from '../config.js'

export const COLOUR = {
    BODY_BACKGROUND: '#C0C0C0',
    SELECTED_MENU_ITEM_FONT_COLOUR: '#666666',
    DOWNLOAD_HEADER_FONT_COLOUR: SETTINGS[PLATFORM].REACT_APP_SECONDARY_FONT_COLOUR,
    PLUGIN_HEADERS_COLOUR: SETTINGS[PLATFORM].REACT_APP_PRIMARY_COLOUR || '#C0C0C0',
    SELECTED_MENU_ITEM: SETTINGS[PLATFORM].REACT_APP_SECONDARY_COLOUR || '#FBE6E1',
    LINK_COLOUR: SETTINGS[PLATFORM].REACT_APP_LINK_COLOUR || '#7AACF8'
}
